export const SETSETTINGSSAVE = "SETSETTINGSSAVE";
export const SETEXPSETLOCLIST = "SETEXPSETLOCLIST";
export const SETEXPSETSELECTTAX = "SETEXPSETSELECTTAX";
export const SETEXPSETSERIESLIST = "SETEXPSETSERIESLIST";
export const SETEXPSETTINGGET = "SETEXPSETTINGGET";
export const SETEXPSETSACLIST = "SETEXPSETSACLIST";